import { LitElement, html, svg } from 'lit';

export class IconExpand32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>To diagonale piler pekende i hver sin retning</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 19.999 2 30M21.333 1.333h9v8.97M10.333 30.333h-9v-8.962M30 2l-10 9.999"></path></svg>`; }
}
if (!customElements.get('f-icon-expand32', IconExpand32)) {
  customElements.define('f-icon-expand32', IconExpand32);
}